import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf, CurrencyPipe } from '@angular/common';
import { ItemOrder } from '../../../services/orders/interfaces/order.interface';

@Component({
  selector: 'app-item-order',
  standalone: true,
  imports: [NgClass, NgIf, CurrencyPipe],
  templateUrl: './item-order.component.html',
  styleUrl: './item-order.component.css'
})


export class ItemOrderComponent {
  @Input()
  item: ItemOrder = new ItemOrder();

  @Input() canEdit: boolean = true;
  @Input() canCancel: boolean = false;

  @Output() removeItem = new EventEmitter<string>();
  @Output() addItem = new EventEmitter<string>();
  @Output() cancelItem = new EventEmitter<string>();
  @Output() changeStatus = new EventEmitter<{ uuid: string, nextStatus: string }>();

  onRemoveItem($event: any) {
    if (this.canEdit) this.removeItem.emit(this.item.uuid);
  }

  onAddItem($event: any) {
    if (this.canEdit) this.addItem.emit(this.item.uuid);
  }

  onCancelItem($event: any) {
    if (this.canCancel) this.cancelItem.emit(this.item.uuid);
  }

  onAdvanceStatus(nextStatus: string) {
    if (!nextStatus) return;
    this.changeStatus.emit({ uuid: this.item.uuid, nextStatus });
  }

  // Determine a single primary next status to advance to (prefer non-canceled)
  getPrimaryNextStatus(): string | null {
    const list = this.item.allowedNextStatuses || [];
    if (!list.length) return null;
    const preferred = list.find(s => s !== 'canceled');
    return preferred || list[0] || null;
  }

  onAdvancePrimary() {
    const next = this.getPrimaryNextStatus();
    if (!next) return;
    this.onAdvanceStatus(next);
  }

  // Badge helpers
  getStatusBadgeClass(slug: string | undefined): string {
    const s = (slug || 'pending').toLowerCase();
    switch (s) {
      case 'delivered':
        return 'badge rounded-pill bg-success text-white';
      case 'ready':
        return 'badge rounded-pill bg-primary text-white';
      case 'picked':
        return 'badge rounded-pill bg-info text-white';
      case 'sent':
        return 'badge rounded-pill bg-warning text-dark';
      case 'canceled':
        return 'badge rounded-pill bg-danger text-white';
      case 'pending':
      default:
        return 'badge rounded-pill bg-white text-dark border border-secondary';
    }
  }

  getStatusLabel(slug: string | undefined): string {
    const s = (slug || 'pending').toLowerCase();
    switch (s) {
      case 'delivered':
        return 'DELIVERED';
      case 'ready':
        return 'READY';
      case 'picked':
        return 'PICKED';
      case 'sent':
        return 'SENT';
      case 'canceled':
        return 'CANCELED';
      case 'pending':
      default:
        return 'PENDING';
    }
  }

  // Opciones seleccionadas: soporta optionSnapshots, options o menuProductOption único
  getOptionNames(): string[] {
    const src: any[] = (this.item as any)?.optionSnapshots || (this.item as any)?.options || [];
    if (Array.isArray(src) && src.length > 0) {
      return src
        .map((o: any) => (o?.nameSnapshot || o?.name || '').toString().trim())
        .filter((n: string) => !!n);
    }
    const single = (this.item as any)?.menuProductOption?.name || '';
    return single ? [String(single)] : [];
  }
}


